import React from 'react';
import { useNavigate } from 'react-router-dom';
import './TopBar.css';

/**
 * The Editing Room's slim top bar (Unit 4 build spec §C2): story/scene
 * breadcrumb + a way back to the outline. No outline sidebar, no
 * full-bleed — this is the entire chrome above the room's content, unlike
 * BrainstormyLayout's persistent nav/panels, which this route deliberately
 * opts out of (design brief §1: "a separate room, not a Story Board panel").
 */
export default function TopBar({ storyName, sceneTitle, statusLabel, rightSlot }) {
  const navigate = useNavigate();
  return (
    <header className="er-topbar">
      <div className="er-topbar__left">
        <button type="button" className="er-topbar__back" onClick={() => navigate(-1)}>
          ← Outline
        </button>
        {(storyName || sceneTitle) && (
          <>
            <span className="er-topbar__divider" aria-hidden="true" />
            <span className="er-topbar__breadcrumb">
              {storyName && <span>{storyName}</span>}
              {storyName && sceneTitle && <span aria-hidden="true"> / </span>}
              {sceneTitle && <span className="er-topbar__scene-name">{sceneTitle}</span>}
            </span>
          </>
        )}
      </div>
      <div className="er-topbar__right">
        {statusLabel && <span className="er-topbar__status">{statusLabel}</span>}
        {rightSlot}
      </div>
    </header>
  );
}
